import $ from 'jquery';

const swedishTranslations = {
  monthNames: ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'],
  monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
  dayNames: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
  dayNamesShort: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'],
  dayNamesMin: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
  closeText: 'Stäng',
  prevText: 'Tidigare',
  nextText: 'Senare',
};

const DISPLAY_DATE_FORMAT = 'dd/mm/yy';
const SUBMIT_DATE_FORMAT = 'yy-mm-dd';

const initDatepicker = (el) => {
  const $datepicker = $(el);

  if ($datepicker.data('mstDatepickerInitialized') === true) {
    return;
  }

  // If datepicker isn't available, do not crash the page.
  if (typeof $.fn.datepicker !== 'function') {
    $datepicker.data('mstDatepickerInitialized', true);
    return;
  }

  let $activeInput = $datepicker;
  const inputType = ($datepicker.attr('type') || '').toLowerCase();

  // If input is type=date → keep it as submit field, create a visible text input for the UI.
  if (inputType === 'date' && $datepicker.attr('id')) {
    const hiddenId = $datepicker.attr('id');
    const originalClasses = ($datepicker.attr('class') || '')
      .split(' ')
      .filter(Boolean)
      .filter((c) => c !== 'hasDatepicker')
      .join(' ');

    $datepicker
      .attr('type', 'hidden')
      .removeAttr('placeholder')
      .removeClass('hasDatepicker');

    const currentLanguage = drupalSettings &&
      drupalSettings.path &&
      drupalSettings.path.currentLanguage;
    const placeholderString = currentLanguage === 'en' ? 'Date' : 'Datum';

    const $displayInput = $('<input />', {
      type: 'text',
      id: `${hiddenId}-display`,
      class: [originalClasses, 'sdt-datepicker-display', 'form-text'].filter(Boolean).join(' '),
      autocomplete: 'off',
      inputmode: 'none',
      placeholder: placeholderString,
    });

    $displayInput.attr('data-sdt-datepicker-for', hiddenId);
    const drupalSelector = $datepicker.attr('data-drupal-selector');
    if (drupalSelector) {
      $displayInput.attr('data-drupal-selector', `${drupalSelector}-display`);
    }

    $datepicker.before($displayInput);

    $displayInput.datepicker({
      dateFormat: DISPLAY_DATE_FORMAT,
      altField: `#${hiddenId}`,
      altFormat: SUBMIT_DATE_FORMAT,
      showButtonPanel: true,
      onSelect() {
        $datepicker.trigger('change');
      },
    });

    // If hidden field has a prefilled value → reflect it in display field.
    const hiddenValue = ($datepicker.val() || '').trim();
    if (hiddenValue) {
      try {
        const parsed = $.datepicker.parseDate(SUBMIT_DATE_FORMAT, hiddenValue);
        $displayInput.datepicker('setDate', parsed);
      } catch (e) {
        // Ignore
      }
    }

    $activeInput = $displayInput;
  }

  // Overlay
  let $overlay = $('.overlay.overlay--datepicker');
  if ($overlay.length === 0) {
    $overlay = $('<div />', { class: 'overlay overlay--datepicker' });
    $('body').append($overlay);
  }

  const datepickerPopupHtml = document.getElementById('ui-datepicker-div');
  if (datepickerPopupHtml) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          if (datepickerPopupHtml.style.display === 'none') {
            $overlay.removeClass('is-open');
          } else {
            datepickerPopupHtml.style.display = 'flex';
            $overlay.addClass('is-open');
            $activeInput.attr('inputmode', 'none');
          }
        }
      });
    });
    observer.observe(datepickerPopupHtml, { attributes: true, childList: true, subtree: true });
  }

  // jQuery UI options
  $activeInput.datepicker('option', 'monthNames', swedishTranslations.monthNames);
  $activeInput.datepicker('option', 'monthNamesShort', swedishTranslations.monthNamesShort);
  $activeInput.datepicker('option', 'dayNames', swedishTranslations.dayNames);
  $activeInput.datepicker('option', 'dayNamesShort', swedishTranslations.dayNamesShort);
  $activeInput.datepicker('option', 'dayNamesMin', swedishTranslations.dayNamesMin);
  $activeInput.datepicker('option', 'closeText', swedishTranslations.closeText);
  $activeInput.datepicker('option', 'prevText', swedishTranslations.prevText);
  $activeInput.datepicker('option', 'nextText', swedishTranslations.nextText);
  $activeInput.datepicker('option', 'firstDay', 1);
  $activeInput.datepicker('option', 'showButtonPanel', true);
  $activeInput.datepicker('option', 'dateFormat', DISPLAY_DATE_FORMAT);

  // Mark dates with results
  const datesWithResults = (drupalSettings && drupalSettings.datesWithResults) || [];
  $activeInput.datepicker('option', 'beforeShowDay', (date) => {
    const dateString = $.datepicker.formatDate('yy-mm-dd', date);
    return [datesWithResults.includes(dateString)];
  });

  $datepicker.data('mstDatepickerInitialized', true);
  $activeInput.data('mstDatepickerInitialized', true);
};

((Drupal) => {
  Drupal.behaviors.mstDatepicker = {
    attach(context) {
      // `once` is provided by the `core/once` library.
      const elements = (typeof once === 'function')
        ? once('mstDatepicker', '.bef-datepicker', context)
        : $('.bef-datepicker', context).toArray();

      $(elements).each((index, element) => {
        initDatepicker(element);
      });
    },
  };
})(Drupal);
